import React from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import type { Side } from "@design-system/overlay/overlayPositioning";
import styles from "./StatusIndicator.module.scss";

export type StatusIndicatorVariant =
    | "gray"
    | "yellow"
    | "green"
    | "blue"
    | "purple"
    | "red";

interface StatusIndicatorProps {
    variant: StatusIndicatorVariant;
    label: string;
    appearance?: "outlined" | "solid";
    showText?: boolean;
    className?: string;
    textClassName?: string;
    tooltipLabel?: string;
    tooltipSide?: Side;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
    variant,
    label,
    appearance = "outlined",
    showText = false,
    className,
    textClassName,
    tooltipLabel,
    tooltipSide,
}) => {
    const indicator = (
        <div
            className={classNames(
                styles.statusContainer,
                styles[appearance],
                className,
            )}
        >
            <div className={classNames(styles.statusDot, styles[variant])} />
            {showText && (
                <span className={classNames(styles.statusText, textClassName)}>
                    {label}
                </span>
            )}
        </div>
    );

    if (showText) {
        return indicator;
    }

    return (
        <Tooltip content={tooltipLabel ?? label} side={tooltipSide}>
            {indicator}
        </Tooltip>
    );
};
